import VueRouter from "vue-router";

const Redirect = () => import("@/views/Redirect/Index"); // 登录重定向页
const SearchResult = () => import("@/views/SearchResult/Index"); // 查询结果页

export default new VueRouter({
  routes: [
    {
      path: "/",
      redirect: "SearchResult",
    },
    {
      path: "/Redirect",
      name: "Redirect",
      component: Redirect,
    },
    {
      path: "/SearchResult",
      name: "SearchResult",
      component: SearchResult,
    },
  ],
});
